import axios from 'axios'
import configs from '../configs'
import Qs from 'qs'
import app from '../main'
import Messager from '@/lib/Messager'
import store from '@/store'
import User from '../models/User'

const http = axios

http.defaults.headers.post['Content-Type']='application/json;charset=UTF-8'
http.defaults.withCredentials=true
http.defaults.timeout = 5000
http.defaults.baseURL = configs.baseUrl

const cleanLoginInfo = () => {
    store.commit('setCurrentUser', new User())
}

const isUnAuthorError = (error) => {
    return error && isUnAuthorResponse(error.response)
}

const isUnAuthorResponse = (response) => {
    return response && response.data && (
        response.status === 401 || response.status === 403
    )
}

const consumeUnAuthorCode = (code) => {
    Messager.processError(code)
    redirectToLogin()
    cleanLoginInfo()
}

const consumeError = (message) => {
    Messager.showErr(message)
}

const redirectToLogin = () => {
    app.$router.push('/login')
}

const isOk = (response) => {
    return response.status === 200
}

http.interceptors.response.use(
    response => {
        if(isUnAuthorResponse(response)) {
            consumeUnAuthorCode(response.status)
        }
        if(!isOk(response)) {
            if(response.data && response.data.message) {
                consumeError(response.data.message)
            } else {
                consumeError("发生错误，错误码：" + response.status)
            }
        }
        return response
    },
    error => {
        console.log(error)
        if(isUnAuthorError(error)) {
            consumeUnAuthorCode(error.response.status)
        }
        if(error.response) {
            if(!isOk(error.response)) {
                if(error.response.data && error.response.data.message) {
                    consumeError(error.response.data.message)
                } else {
                    Messager.processError(error.response.status)
                }
            }
        } else {
            if (error.code === 'ECONNABORTED') {
                Messager.showErr("连接超时，远端服务器可能不在线。", "网络异常")
            } else {
                Messager.showErr(error.message)
            }
        }
        return Promise.reject(error)
    }
)

const promise = (pro) => {
    return new Promise((resolve, reject) => pro.then(resp => {
        if(resp.status === 200) {
            resolve(resp)
        } else {
            reject(resp)
        }
    }).catch(err => reject(err)))
}

const get = (url, params) => promise(http.get(url, {params}))

const post = (url, query, config) => promise(http.post(url, query, config))

const formPost = (url, data, params) => promise(http({
    url: configs.baseUrl + url,
    method: 'post',
    headers: {
        'Content-Type' : 'application/x-www-form-urlencoded'
    },
    params: params,
    data: Qs.stringify(data, {arrayFormat: 'brackets'}),
    paramsSerializer: (p) => Qs.stringify(p, {arrayFormat: 'brackets'}),
    timeout: 5000
}))

const fileDataPost = (url, params) => {

    const formData = new FormData()

    for (const p in params) {
        if (Object.hasOwnProperty.call(params, p)) {
            const e = params[p];
            formData.append(p, e)
        }
    }

    return promise(http({
        url : configs.baseUrl + url,
        method: 'post',
        headers: {
            'Content-Type' : 'multipart/form-data'
        },
        data: formData
    }))
}

const del = (url, params) => promise(http.delete(url, {params: params}))

export default {
    client: axios,
    get,
    post,
    del,
    formPost,
    fileDataPost
}
